const genHorizontalStyle = token => {
  const {
    componentCls
  } = token;
  const stepsItemCls = "".concat(componentCls, "-item"); // .ant-steps-item
  return {
    ["".concat(componentCls, "-horizontal")]: {
      ["".concat(stepsItemCls, "-tail")]: {
        transform: 'translateY(-50%)'
      }
    }
  };
};
export default genHorizontalStyle;